import * as React from 'react'
import styled from 'styled-components'
import { gray } from '../../ui/utils/_colors'

interface InfoBoxProps {
  maxWidth: string
  backgroundColor: string
  backgroundBorderColor?: string
  icon?: React.ReactElement
  title?: string
  text: string | React.ReactElement
}

export const InfoBox: React.FC<InfoBoxProps> = ({ maxWidth, backgroundColor, backgroundBorderColor, icon, title, text }) => {
  return (
    <MainContainer maxWidth={maxWidth} backgroundColor={backgroundColor} backgroundBorderColor={backgroundBorderColor}>
      <InfoBoxRowView>
        {icon ? icon : undefined}

        <TextColumnView>
          {title ? <Title>{title}</Title> : undefined}
          <Text>{text}</Text>
        </TextColumnView>
      </InfoBoxRowView>
    </MainContainer>
  )
}

const MainContainer = styled.div<InfoBoxProps>`
  width: 100%;
  max-width: ${(props: InfoBoxProps) => props.maxWidth};
  height: auto;
  padding: 16px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  border-radius: 4px;
  background: ${(props: InfoBoxProps) => props.backgroundColor};
  border: 1px solid ${(props: InfoBoxProps) => props.backgroundBorderColor || props.backgroundColor};
`

const InfoBoxRowView = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  
  align-items: flex-start;
  gap: 8px;
`

const TextColumnView = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start; 
  align-items: flex-start; 
  gap: 8px;
`

const Title = styled.span`
  font-family: Inter;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: ${gray.scale800};
`

const Text = styled.span`
  width: 100%;

  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;

  line-height: 16px;
  text-align: left;
  letter-spacing: 0px;
  color: ${gray.scale800};
`